import { render } from "./AccountCreateView.vue?vue&type=template&id=28e23b13"
import script from "./AccountCreateView.vue?vue&type=script&lang=js"
export * from "./AccountCreateView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\cbetta\\Desktop\\workspace\\Developpement\\_VELO\\demo-location.accen.me\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__